<svg class="barchart"></svg>
<div class="selectedRange Spacebox__t-tiny Flexbox Flexbox__flex-1">
    <div class="from Flexbox__just-start Spacebox__l-medium Flexbox Flexbox__flex-1" >
        <span  *ngIf="rangeFrom >= 0">{{'from' | translate}}: {{rangeFrom}} </span>
    </div>
    <div class="to Spacebox__r-small Flexbox Flexbox__flex-1 Flexbox__just-end" >
        <span class="to" *ngIf="rangeTo >= 0">{{'to' | translate}}: {{rangeTo}}</span>
    </div>
</div>
